import Vue from "vue";

const state = {
  header: "UK's first dental supply marketplace",
  subHeader:
    "Make your products available to thousands of companies looking for your products...",
  uniqueSellingPoints: [
    {
      header: "Increased Reach",
      icon: "increased_reach.svg",
      content: "We advertise your products across<br> web and social channels"
    },
    {
      header: "Risk Free",
      icon: "risk_free.svg",
      content: "Only pay when you earn.<br> We don't charge subscription fees"
    },
    {
      header: "Easy Setup",
      icon: "easy_setup.svg",
      content:
        "It's easy to get started and we're <br> here to offer a helping hand"
    }
  ],
  signupHeader: "Increase your sales and reach new markets",
  outReachHeader:
    "Reach thousands of businesses<br> shopping for dental supply",
  signupSubHeader: "Grow your sales today!",
  features: [
    {
      header: "Intuitive Sales Dashboard",
      text:
        "Manage your orders through our intuitive sales dashboard. See how much revenue you have made, what your average order value is, how your financial performance fluctuates over time and easily see customer and shipping details.",
      img: "dashboard.svg",
      class: "appRed white--text"
    },
    {
      header: "Dedicated Account Management",
      text:
        "You can manage your product availability and stock levels easily via your dashboard. However, if you require a helping hand, our account managers are readily available to set you up and support you to grow your sales every step of the way.",
      img: "product-dashboard.svg",
      class: "white black--text"
    }
  ]
};

const getters = {};

const actions = {
  CREATE_LEAD: function(context, payLoad) {
    return Vue.prototype.$axios
      .post("/suppliers/leads", payLoad)
      .then(response => {
        return response;
      })
      .catch(err => {
        throw new Error(err.response.data.meta.message);
      });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

// import Vue from "vue";

// const state = {
//   header: "UK's first dental supply marketplace",
//   subHeader:
//     "Make your products available to thousands of companies looking for your products...",
//   uniqueSellingPoints: [
//     {
//       header: "Increased Reach",
//       icon: "increased_reach.svg",
//       content:
//         "We advertise your products across<br> web and social channels"
//     },
//     {
//       header: "Risk Free",
//       icon: "risk_free.svg",
//       content: "Only pay when you earn.<br> We don't charge subscription fees",
//     },
//     {
//       header: "Easy Setup",
//       icon: "easy_setup.svg",
//       content:
//         "It's easy to get started and we're <br> here to offer a helping hand"
//     }
//   ],
//   signupHeader: "Increase your sales and reach new markets",
//   outReachHeader: "Reach thousands of businesses<br> shopping for dental supply",
//   signupSubHeader: "Get started today!",
//   features: [
//     {
//       header: "Intuitive Sales Dashboard",
//       text:
//         "Manage your orders through our intuitive sales dashboard. See how much revenue you have made, what your average order value is, how your financial performance fluctuates over time and easily see customer and shipping details.",
//       img:
//         "sales-dashboard.png",
//       class: "appRed white--text"
//     },
//     {
//       header: "Price Comparison",
//       text:
//         "We provide a comparison of supplier's prices for your selected product so you can lock in great savings",
//       img:
//         "account-management.png"
//     }
//   ]
// };

// const getters = {};

// const actions = {
//   CREATE_LEAD: function(context, payLoad) {
//     return Vue.prototype.$axios
//       .post("/customers/leads", payLoad)
//       .then(response => {
//         return response;
//       })
//       .catch(err => {
//         throw new Error(err.response.data.meta.message);
//       });
//   }
// };

// const mutations = {};

// export default {
//   namespaced: true,
//   state,
//   getters,
//   actions,
//   mutations
// };
